import axios from 'axios';
import { ShippingFormValues } from '../utils/form';
import { Nonce } from '../types';

const BASE_ENDPOINT = 'https://flowers-go-walk-api-prod.herokuapp.com';

export async function getNonce(address: string): Promise<Nonce> {
  const resp = await axios.get<any>(`${BASE_ENDPOINT}/auth/${address}`, {
    validateStatus: (status) => status < 500,
  });
  if (resp.status !== 200) {
    throw new Error(resp?.data?.message || 'Unknown error');
  }
  if ((resp.data?.status || 'error') !== 'success') {
    throw new Error(resp?.data?.message || 'Unknown error');
  }

  return resp.data.data as Nonce;
}

export async function submitAndVerify(
  address: string,
  signature: string,
  token: number,
  shippingAddress: ShippingFormValues
) {
  const resp = await axios.post<any>(
    `${BASE_ENDPOINT}/verify/${address}/${signature}/${token}`,
    {
      shippingAddress: shippingAddress,
    },
    {
      validateStatus: (status) => status < 500,
    }
  );
  if (resp.status !== 201) {
    throw new Error(resp?.data?.message || 'Unknown error');
  }
  if ((resp.data?.status || 'error') !== 'success') {
    throw new Error(resp?.data?.message || 'Unknown error');
  }
}
